import { Box, Grid, MenuItem, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CustomerIntakeForm } from '../types/CustomerIntakeForm';

interface OnboardingCustomerProfileProps {
  formData: CustomerIntakeForm;
  handleChange: (field: keyof CustomerIntakeForm, value: string | number) => void;
}

const SECTORS = ['Healthcare', 'Education', 'Corporate', 'Local Government', 'Facilities Management', 'Other'];
const OPERATING_MODELS = ['Managed Service', 'Cost Plus', 'Concession', 'Nominated Supplier'];

const OnboardingCustomerProfile: React.FC<OnboardingCustomerProfileProps> = ({ formData, handleChange }) => {
  const { t } = useTranslation('common');
  const textFieldMargin = { mb: 8 };

  return (
    <Box sx={{ p: 6, paddingBottom: 0 }}>
      <Grid container
        spacing={3}>
        <Grid item
          xs={12}
          sx={{ pr: 4 }}
          md={6}>
          <TextField
            fullWidth
            required
            label={t('onboardingIntake.customerName', 'Client name')}
            value={formData.name}
            onChange={(e) => handleChange('name', e.target.value)}
            sx={textFieldMargin}
          />
          <TextField select
            fullWidth
            required
            label={t('onboardingIntake.sector', 'Sector')}
            value={formData.sector}
            onChange={(e) => handleChange('sector', e.target.value)}
            sx={textFieldMargin}>
            {SECTORS.map((option) => (
              <MenuItem key={option}
                value={option}>{option}</MenuItem>
            ))}
          </TextField>
          <TextField select
            fullWidth
            required
            label={t('onboardingIntake.operatingModel', 'Operating model')}
            value={formData.operatingModel}
            onChange={(e) => handleChange('operatingModel', e.target.value)}
            sx={textFieldMargin}>
            {OPERATING_MODELS.map((option) => (
              <MenuItem key={option}
                value={option}>{option}</MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item
          sx={{ pl: 4 }}
          xs={12}
          md={6}>
          <TextField
            fullWidth
            required
            label={t('onboardingIntake.accountOwner', 'Account owner')}
            value={formData.owner}
            onChange={(e) => handleChange('owner', e.target.value)}
            sx={textFieldMargin}
          />
          <TextField
            fullWidth
            required
            type="number"
            label={t('onboardingIntake.sitesCount', 'Number of locations')}
            value={formData.sitesCount}
            onChange={(e) => handleChange('sitesCount', e.target.value === '' ? '' : Number(e.target.value))}
            sx={textFieldMargin}
          />
          <TextField
            fullWidth
            required
            type="date"
            label={t('onboardingIntake.targetGoLive', 'Target go-live date')}
            InputLabelProps={{ shrink: true }}
            value={formData.targetGoLive}
            onChange={(e) => handleChange('targetGoLive', e.target.value)}
            sx={textFieldMargin}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default OnboardingCustomerProfile;
